import { render } from "./df-global-loading.vue?vue&type=template&id=782e5fb0&scoped=true"
import script from "./df-global-loading.vue?vue&type=script&lang=js"
export * from "./df-global-loading.vue?vue&type=script&lang=js"

import "./df-global-loading.vue?vue&type=style&index=0&id=782e5fb0&scoped=true&lang=css"

import exportComponent from "D:\\phpEnv\\www\\zy\\frontend\\zhiyadu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-782e5fb0"]])

export default __exports__